import type { SVGProps } from 'react'
const IconClipboardTextIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.927 3.75a.606.606 0 0 0-.607.606v.573c0 .335.272.607.607.607h4.646a.606.606 0 0 0 .607-.607v-.573a.606.606 0 0 0-.607-.606zm-2.107.606c0-1.163.943-2.106 2.107-2.106h4.646c1.164 0 2.107.943 2.107 2.106v.573a2.106 2.106 0 0 1-2.107 2.107H9.927A2.106 2.106 0 0 1 7.82 4.929z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.571 5.344a3.005 3.005 0 0 0-3.005 3.004v8.898a3.005 3.005 0 0 0 3.005 3.004h7.36a3.005 3.005 0 0 0 3.004-3.004V8.348a3.005 3.005 0 0 0-3.005-3.004.75.75 0 1 1 0-1.5 4.505 4.505 0 0 1 4.505 4.504v8.898a4.505 4.505 0 0 1-4.505 4.504H8.571a4.505 4.505 0 0 1-4.505-4.504V8.348a4.505 4.505 0 0 1 4.505-4.504.75.75 0 0 1 0 1.5"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.482 10.941a.75.75 0 0 1 .75-.75h3.018a.75.75 0 0 1 0 1.5H9.232a.75.75 0 0 1-.75-.75m0 4.007a.75.75 0 0 1 .75-.75h6.035a.75.75 0 0 1 0 1.5H9.232a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
)
export default IconClipboardTextIcon
